/**
 * 访客记录 跟卖 埋点上报工具
 * 1 没有登陆 不用上报
 * 2 上报过了 不用上报(监控页面内的跳转)
 * 3 首页 商详 搜索 小店 云币 专题
 */
import YunJi from './YunJi'

const reportConst = {
  cloudCoin: {
    pageId: 81219,
    pointId: 30285
  }
}

let reportInfoList = []
let loginFlag = -1

/**
 * 
 * @param {*} shopId  这里不关心shopId 只是用来判断是否有效登陆中
 * @returns 
 */
function checkIsLoginNew(shopId = 968) {
  return new Promise((resolve) => {
    $.ajax({
      url: `//${globalConfig.linkBasePath}/yunjiuserapp/userapp/checkUserTypeV3.json`,
      data: {
        shopId,
        aind: 1,
        appCont:0 
      },
      method: 'GET',
      success: (res) => {
        resolve(res.errorCode == 0 ? 1 : 0);
      },
      error: () => {
        resolve(0)
      }
    })
  })
}

/**
 * 获取访客记录
 * @returns 
 */
function getVanguardStorage() {
  return JSON.parse(sessionStorage.getItem('yjxianfeng')) || []
}

function setVanguardStorage(arg) {
  sessionStorage.setItem('yjxianfeng',JSON.stringify(arg))
}

/**
 * @constructor 
 * 根据shopId
 */
function checkHadReport(pageName) {
  reportInfoList = getVanguardStorage()
  const storeFlag = reportInfoList.length > 0 && reportInfoList.some(o => o.storeFlag == 3)
  console.log(pageName ? `页面${pageName}`:'', ' 访客记录：：', storeFlag ? '已上报': '没有上报过')
  return storeFlag
}

function checkNeedReport(options = {} ,pageName, type = 0) {
  reportInfoList = getVanguardStorage()
  let flag = 1 // 初始化状态
  // 初始化数据时才执行此判断
  if (reportInfoList.length > 0) {
    console.log('页面：'+pageName,' 访客记录埋点 监控页面内的跳转不需要重复上报')
    flag = -1
  } else if(checkHadReport(pageName)) {
    console.log('页面：'+pageName,' 访客记录埋点 上报过了 不用上报')
    flag = -3
  }
  if(flag > 0) console.log('页面：'+pageName,' checkNeedReport:: 可以上报, flag=', flag)
  return flag
}


/**
 * 上报过的更新标示
 */
function updateVanguardStorage(pageName,shopId) {
  reportInfoList = getVanguardStorage()
  const sho =  reportInfoList.find(o => o.storePageName == pageName)
  if(sho) {
    sho.storeFlag = 3
  }
  setVanguardStorage(reportInfoList)
}

/**
 * 记录 访客记录shopId
 * @param {*} shopId 
 */
export async function initVanguard(pageName, shopId, checkFlag) {
  
  reportInfoList = getVanguardStorage() 

  if(!reportInfoList.some(o => o.storeValue == shopId && o.storePageName == pageName)) {
    reportInfoList.push({
      storePageName: pageName,
      storeValue: shopId,
      storeFlag: checkFlag // 3已上报 1待上报 2待上报(没登陆时) 剩下的 和 checkNeedReport 中的 flag 对应
    })
  }
  setVanguardStorage(reportInfoList)
}

function sleepTime() {
  return new Promise((reolve) => {
    let t = setTimeout(() => {
      reolve()
      clearTimeout(t)
      t = null
    }, 600)
  })
}

/**
 * 执行上报
 * @param {*}  
 * @returns 
 */
export async function doVanguardReport(pageName, shopId) {

  // 上报校验
  const checkFlag = checkNeedReport({}, pageName, 1)
  // 异常标示 中断
  if(checkFlag < 0) return
  initVanguard(pageName, shopId, checkFlag)
  
  reportInfoList = getVanguardStorage()
  // 先取未登录
  let repo = reportInfoList.find(o => o.storeFlag == 2)
  // 再取可上报
  if(!repo) {
    repo = reportInfoList.find(o => o.storeFlag == 1)
  }

  if(!repo) {
    console.log('查询异常 不上报')
    return
  }
  // ======上报=====过程

  // 拿当前人的id
  const reShopId = repo.storeValue
  const rePageName = repo.storePageName
  const reConsumerId = YunJi.getCookie("burial_point_cid")
  // 上报参数
  const {pageId, pointId} = reportConst[rePageName]
  const reportInfo = {
    page_id: pageId,
    point_id: pointId,
    store_id: reShopId,
    participate_user_id: reConsumerId,
    page_name: rePageName,
  }
  console.log('访客记录上报参数：', reportInfo)
  // thinkingReport 对象可能还没生存 等待
  if(!thinkingReport) await sleepTime()
  thinkingReport.track('page_load', reportInfo)
  // 更新session
  updateVanguardStorage(rePageName, shopId)
}
